import { RESTApi, AppsApi, CurrentUserApi, CountersApi, BillingApi } from './methods';

import { IHttpTransport } from '@interfaces';

export class Api {

	static transport: IHttpTransport;

	static app = new RESTApi(Api);
	static apps = new AppsApi(Api);
	static currentUser = new CurrentUserApi(Api);
	static counters = new CountersApi(Api);
	static billing = new BillingApi(Api);

	static setTransport(transport: IHttpTransport) {
		this.transport = transport;
	}

	static getTransport(): IHttpTransport {
		return this.transport;
	}

}
